import * as Sentry from '@sentry/react';

export const logException = (error: unknown, extras?: Record<string, unknown>) => {
  Sentry.captureException(error, { extra: extras });
};

export const logMessage = (message: string): void => {
  Sentry.captureMessage(message);
};
